import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const quickLinks = [
  { label: "Accueil", path: "/", icon: "ri-home-line" },
  { label: "Le Club", path: "/club", icon: "ri-building-line" },
  { label: "Sport", path: "/sport", icon: "ri-football-line" },
  { label: "Communauté", path: "/communaute", icon: "ri-team-line" },
  { label: "Boutique", path: "/boutique", icon: "ri-shopping-bag-line" },
  { label: "Actualités", path: "/actualites", icon: "ri-newspaper-line" },
];

export default function NotFound() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Top accent bar */}
      <div className="h-1.5 bg-gradient-to-r from-[#E8521A] via-[#1A8C7A] to-[#E8521A]"></div>

      <div className="flex-1 flex items-center justify-center px-6 py-20">
        <div className="max-w-2xl w-full text-center">

          {/* Animated 404 */}
          <div className="relative mb-8">
            <div className="text-[180px] font-black leading-none select-none"
              style={{
                background: "linear-gradient(135deg, #E8521A 0%, #1A8C7A 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              404
            </div>
            {/* Floating ball */}
            <div
              className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 rounded-full bg-white flex items-center justify-center"
              style={{ animation: "bounce 2s infinite" }}
            >
              <img
                src="https://static.readdy.ai/image/8057e27537697b1e55795a66bcb46c8e/87d3b0bb4fe39a25c30ecaeca3a3ad0e.jpeg"
                alt="ASC"
                className="w-14 h-14 rounded-full object-cover"
              />
            </div>
          </div>

          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Oups ! Page introuvable
          </h1>
          <p className="text-gray-500 text-lg mb-3">
            La page que vous cherchez n'existe pas ou a été déplacée.
          </p>
          <p className="text-sm text-gray-400 mb-10">
            Redirection automatique vers l'accueil dans{" "}
            <span className="font-bold text-[#E8521A]">{countdown}s</span>
          </p>

          {/* Progress bar */}
          <div className="h-1 bg-gray-200 rounded-full mb-10 overflow-hidden max-w-xs mx-auto">
            <div
              className="h-full bg-gradient-to-r from-[#E8521A] to-[#1A8C7A] rounded-full transition-all duration-1000"
              style={{ width: `${((10 - countdown) / 10) * 100}%` }}
            ></div>
          </div>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-14">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-[#E8521A] text-white font-semibold hover:bg-[#d44a16] transition-colors whitespace-nowrap"
            >
              <i className="ri-home-line"></i>
              Retour à l'accueil
            </Link>
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full border-2 border-gray-300 text-gray-700 font-semibold hover:border-[#E8521A] hover:text-[#E8521A] transition-colors whitespace-nowrap"
            >
              <i className="ri-arrow-left-line"></i>
              Page précédente
            </button>
          </div>

          {/* Quick Links */}
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
            <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-5">
              Où voulez-vous aller ?
            </p>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
              {quickLinks.map(link => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-orange-50 hover:text-[#E8521A] text-gray-700 transition-colors group"
                >
                  <span className="w-9 h-9 flex items-center justify-center bg-gray-100 group-hover:bg-orange-100 rounded-lg transition-colors">
                    <i className={`${link.icon} text-gray-500 group-hover:text-[#E8521A] transition-colors`}></i>
                  </span>
                  <span className="text-sm font-medium">{link.label}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom accent */}
      <div className="h-1.5 bg-gradient-to-r from-[#1A8C7A] via-[#E8521A] to-[#1A8C7A]"></div>

      <style>{`
        @keyframes bounce {
          0%, 100% { transform: translate(-50%, -50%) translateY(0); }
          50% { transform: translate(-50%, -50%) translateY(-12px); }
        }
      `}</style>
    </div>
  );
}